module.exports = __webpack_public_path__ + "img/fangchan_bg.ca79abde.png";